import { render, staticRenderFns } from "./homeworkList.vue?vue&type=template&id=98f42caa&scoped=true"
import script from "./homeworkList.vue?vue&type=script&lang=js"
export * from "./homeworkList.vue?vue&type=script&lang=js"
import style0 from "./homeworkList.vue?vue&type=style&index=0&id=98f42caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f42caa",
  null
  
)

export default component.exports